import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Search = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.5815 9.87442C11.4664 8.82908 12 7.47685 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C7.47685 12 8.82908 11.4664 9.87442 10.5815L14.5 15.2071L15.2071 14.5L10.5815 9.87442ZM6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11Z"
  />,
  'Search'
)

export default Search
